import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../common/html/icon'
import { PopupAction } from '../../../common/popup/PopupAction'
import {
  getFEComponentAuthorized,
  getUserType,
} from '../../../layout/store/thunk'
import { postActiveTrial } from '../store/thunk'
import classes from './index.module.scss'

export const PopupTrialNow = ({ isShow, setIsShow }) => {
  const dispatch = useDispatch()

  const handleClose = () => {
    setIsShow(false)
  }

  const handleActiveTrial = () => {
    dispatch(postActiveTrial({}))
      .unwrap()
      .then(() => {
        dispatch(getUserType())
        dispatch(getFEComponentAuthorized())
        setIsShow(false)
      })
      .catch(() => {})
  }

  return (
    <PopupAction
      isShow={isShow}
      btnCancel={{
        label: 'common.NO',
        isI18n: true,
        event: handleClose,
      }}
      btnSubmit={{
        label: 'common.YES',
        isI18n: true,
        event: handleActiveTrial,
      }}
      handleClose={handleClose}
    >
      <div className={classes.popupAlertErrorContainer}>
        <Icon
          className="icon-alert"
          style={{ color: '#E8B714', fontSize: 38 }}
        />
        <div className={classes.messageContainer}>
          <Translate value="subscriptionPayment.TRIAL_MESSAGE" dangerousHTML />
        </div>
      </div>
    </PopupAction>
  )
}
